import { z } from 'zod';

export const searchSchema = z.object({
  // Basic fields
  fromDate: z.string().min(1, 'Kỳ này từ không được để trống'),
  toDate: z.string().min(1, 'Kỳ này đến không được để trống'),
  previousFromDate: z.string().min(1, 'Kỳ trước từ không được để trống'),
  previousToDate: z.string().min(1, 'Kỳ trước đến không được để trống'),
  reportBy: z.string().min(1, 'Báo cáo theo không được để trống'),
  groupBy: z.string().min(1, 'Nhóm theo không được để trống'),

  // General tab
  customerCode: z.string().optional(),
  customerGroup1: z.string().optional(),
  customerGroup2: z.string().optional(),
  customerGroup3: z.string().optional(),
  region: z.string().optional(),
  productCode: z.string().optional(),
  productType: z.string().optional(),
  trackInventory: z.boolean().optional(),
  productGroup1: z.string().optional(),
  productGroup2: z.string().optional(),
  productGroup3: z.string().optional(),
  warehouseCode: z.string().optional(),
  reportTemplate: z.string().optional(),

  // Filter by object tab
  department: z.string().optional(),
  project: z.string().optional(),
  contract: z.string().optional(),
  paymentPhase: z.string().optional(),
  agreement: z.string().optional(),
  fee: z.string().optional(),
  product: z.string().optional(),
  productionOrder: z.string().optional(),
  invalidExpense: z.string().optional(),

  // Other tab
  transactionCode: z.string().optional(),
  employeeCode: z.string().optional(),
  itemAccount: z.string().optional(),
  revenueAccount: z.string().optional(),
  costAccount: z.string().optional(),
  batchCode: z.string().optional(),
  locationCode: z.string().optional(),
  fromDocumentNumber: z.string().optional(),
  toDocumentNumber: z.string().optional(),
  description: z.string().optional(),
  reportFilterTemplate: z.string().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const initialValues: SearchFormValues = {
  fromDate: '',
  toDate: '',
  previousFromDate: '',
  previousToDate: '',
  reportBy: 'customer',
  groupBy: 'product',

  customerCode: '',
  customerGroup1: '',
  customerGroup2: '',
  customerGroup3: '',
  region: '',
  productCode: '',
  productType: '',
  trackInventory: false,
  productGroup1: '',
  productGroup2: '',
  productGroup3: '',
  warehouseCode: '',

  // Filter by object tab fields
  department: '',
  project: '',
  contract: '',
  paymentPhase: '',
  agreement: '',
  fee: '',
  product: '',
  productionOrder: '',
  invalidExpense: '',

  reportTemplate: 'quantity',
  transactionCode: '',
  employeeCode: '',
  itemAccount: '',
  revenueAccount: '',
  costAccount: '',
  batchCode: '',
  locationCode: '',
  fromDocumentNumber: '',
  toDocumentNumber: '',
  description: '',
  reportFilterTemplate: ''
};
